import { render } from "./client.vue?vue&type=template&id=0c32fdcb&scoped=true&ts=true"
import script from "./client.vue?vue&type=script&lang=ts&config=true"
export * from "./client.vue?vue&type=script&lang=ts&config=true"

import "./client.vue?vue&type=style&index=0&id=0c32fdcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c32fdcb"]])

export default __exports__